var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widgets"},[_c('div',{staticClass:"widgets--wrapper"},_vm._l((_vm.defaultWidgets),function(widget,index){return _c('div',{key:index,class:_vm.getWidgetVisibility
          ? 'widgets__content-orders-search'
          : 'widgets__content'},[_c('widget-renderer',{attrs:{"widgetToRender":widget.name,"size":widget.size}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }